module.exports = __webpack_public_path__ + "media/images/front/banner_seminar20181118_2-9ab918bb5fc280a77ae9acf2c2c1f8e7.jpg";